// _neu_generated_code__dont_modify_directly_
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
//CORE_REFERENCE_IMPORTS
//append_imports_start

import { Component, Injector } from '@angular/core'; //_splitter_
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms'; //_splitter_
import { MatDialog } from '@angular/material/dialog'; //_splitter_
import { Router } from '@angular/router'; //_splitter_
import { memberSelectModalComponent } from 'app/components/components/memberSelectModal.component'; //_splitter_
import { SDPageCommonService } from 'app/n-services/sd-page-common.service'; //_splitter_
import { SDBaseService } from 'app/n-services/SDBaseService'; //_splitter_
import { NeuServiceInvokerService } from 'app/n-services/service-caller.service'; //_splitter_
import { DataService } from 'app/sd-services/DataService'; //_splitter_
//append_imports_end

@Component({
  selector: 'bh-searchDetails',
  templateUrl: './searchDetails.template.html',
  providers: [
    //appendnew_element_providers
  ],
})
export class searchDetailsComponent {
  page: any = { dep: {} };
  constructor(
    private __page_injector__: Injector,
    private sdService: SDBaseService,
    public __serviceInvoker__: NeuServiceInvokerService
  ) {
    this.__page_injector__.get(SDPageCommonService).addPageDefaults(this.page);
    this.registerListeners();
    this.page.dep.FormBuilder = this.__page_injector__.get(FormBuilder); //FormBuilder
    //appendnew_element_inject
  }

  ngOnInit() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    {
      this.sd_g2QU2dlJfkf1O32L(bh);
    }
  }

  private registerListeners() {
    let bh = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);

    //append_listeners
  }

  sd_g2QU2dlJfkf1O32L(bh) {
    try {
      bh = this.sd_L8UooNnlAJLHJlVx(bh);
      //appendnew_next_sd_g2QU2dlJfkf1O32L
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_g2QU2dlJfkf1O32L');
    }
  }

  onSearchReport(...others) {
    let bh: any = {};
    try {
      bh = this.__page_injector__
        .get(SDPageCommonService)
        .constructFlowObject(this);
      bh.input = {};
      bh.local = {};
      bh = this.sd_vqJuii5UGFI768z2(bh);
      //appendnew_next_onSearchReport
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_hznedQdEFtSxoch6');
    }
  }
  //appendnew_flow_searchDetailsComponent_start

  sd_L8UooNnlAJLHJlVx(bh) {
    try {
      bh = this.sd_gTJUvSp1UvOmXyjE(bh);
      //appendnew_next_sd_L8UooNnlAJLHJlVx
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_L8UooNnlAJLHJlVx');
    }
  }

  sd_gTJUvSp1UvOmXyjE(bh) {
    try {
      bh = this.sd_opKRDdBWggbfkyyP(bh);
      //appendnew_next_sd_gTJUvSp1UvOmXyjE
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_gTJUvSp1UvOmXyjE');
    }
  }

  sd_opKRDdBWggbfkyyP(bh) {
    try {
      const page = this.page;
      page.searchReportsForm = new FormGroup({
        firstName: new FormControl('', Validators.required),
        middleName: new FormControl(''),
        lastName: new FormControl('', Validators.required),
        pni_address1: new FormControl('', Validators.required),
        pni_address2: new FormControl(''),
        pni_city: new FormControl('', Validators.required),
        pni_state: new FormControl('', Validators.required),
        pni_zip: new FormControl('', Validators.required),
      });
      bh = this.sd_yPsuGTrbM50izlE0(bh);
      //appendnew_next_sd_opKRDdBWggbfkyyP
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_opKRDdBWggbfkyyP');
    }
  }

  async sd_yPsuGTrbM50izlE0(bh) {
    try {
      const DataServiceInstance: DataService =
        this.__page_injector__.get(DataService);

      let outputVariables = await DataServiceInstance.getMethod(
        'fetch-app-config'
      );
      this.page.fetchConfigRes = outputVariables.local.result;

      //appendnew_next_sd_yPsuGTrbM50izlE0
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_yPsuGTrbM50izlE0');
    }
  }

  sd_vqJuii5UGFI768z2(bh) {
    try {
      const page = this.page;
      bh.requestBody = {
        pni_name: page.searchReportsForm.value.firstName,
      };

      bh.fetchUsersUrl = `fetch-users`;
      bh = this.sd_IPC9ORyftaScrgff(bh);
      //appendnew_next_sd_vqJuii5UGFI768z2
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_vqJuii5UGFI768z2');
    }
  }

  async sd_IPC9ORyftaScrgff(bh) {
    try {
      const DataServiceInstance: DataService =
        this.__page_injector__.get(DataService);

      let outputVariables = await DataServiceInstance.postMethod(
        bh.fetchUsersUrl,
        bh.requestBody
      );
      this.page.fetchUserRes = outputVariables.local.result;

      bh = this.sd_RJjIgva7iUwytXvo(bh);
      //appendnew_next_sd_IPC9ORyftaScrgff
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_IPC9ORyftaScrgff');
    }
  }

  sd_RJjIgva7iUwytXvo(bh) {
    try {
      const memberSelectModalDialog = this.__page_injector__.get(MatDialog);
      const memberSelectModalDialogRef = memberSelectModalDialog.open(
        memberSelectModalComponent,
        { data: this.page.fetchUserRes, panelClass: 'panel-class' }
      );
      memberSelectModalDialogRef.afterClosed().subscribe((event) => {
        this.page.selectedUser = event;
        this.sd_9UNO3QJmJxYKXThv(bh);

        //appendnew_next_sd_RJjIgva7iUwytXvo;
      });

      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_RJjIgva7iUwytXvo');
    }
  }

  sd_9UNO3QJmJxYKXThv(bh) {
    try {
      if (
        this.sdService.operators['nnull'](
          this.page.selectedUser,
          undefined,
          undefined,
          undefined
        )
      ) {
        bh = this.sd_dSeUGkcBp4lrPiFz(bh);
      }

      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_9UNO3QJmJxYKXThv');
    }
  }

  sd_dSeUGkcBp4lrPiFz(bh) {
    try {
      const page = this.page;
      console.log(page.selectedUser, 'selectedUser');
      const pni_name = page.selectedUser.pni_name;

      bh.url = `search-reports?pni_name=${pni_name}
&address1=${page.selectedUser.address1}
&address2=${page.selectedUser.address2}
&state=${page.selectedUser.state}
&zip=${page.selectedUser.zip}
&city=${page.selectedUser.city}`;
      bh = this.sd_HthAWeTcuDHgtO9l(bh);
      //appendnew_next_sd_dSeUGkcBp4lrPiFz
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_dSeUGkcBp4lrPiFz');
    }
  }

  async sd_HthAWeTcuDHgtO9l(bh) {
    try {
      const DataServiceInstance: DataService =
        this.__page_injector__.get(DataService);

      let outputVariables = await DataServiceInstance.getMethod(bh.url);
      this.page.searchRes = outputVariables.local.result;

      bh = this.sd_Dwsz4Iuv0YuvQetX(bh);
      //appendnew_next_sd_HthAWeTcuDHgtO9l
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_HthAWeTcuDHgtO9l');
    }
  }

  sd_Dwsz4Iuv0YuvQetX(bh) {
    try {
      const DataServiceInstance: DataService =
        this.__page_injector__.get(DataService);
      DataServiceInstance['searchRes'] = this.page.searchRes;
      bh = this.sd_4lwiFVZ8TITqlDaG(bh);
      //appendnew_next_sd_Dwsz4Iuv0YuvQetX
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_Dwsz4Iuv0YuvQetX');
    }
  }

  async sd_4lwiFVZ8TITqlDaG(bh) {
    try {
      const { paramObj: qprm, path: path } =
        this.sdService.getPathAndQParamsObj('/home/report-summary');
      await this.__page_injector__
        .get(Router)
        .navigate([this.sdService.formatPathWithParams(path, undefined)], {
          queryParams: Object.assign(qprm, ''),
        });
      //appendnew_next_sd_4lwiFVZ8TITqlDaG
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_4lwiFVZ8TITqlDaG');
    }
  }

  //appendnew_node

  ngOnDestroy() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    this.__page_injector__.get(SDPageCommonService).deletePageFromMap(this);
  }

  // error_handler_slot
  private errorHandler(bh, e, src): Promise<any> {
    console.error(e);
    bh.error = e;
    bh.errorSource = src;
    throw e;
  }
  //appendnew_flow_searchDetailsComponent_Catch
}
